import { triggerNavigation } from "../navigationBroker";

const buildListItemMainContent = ({ Url, Label }) => {
  if (Url) {
    const link = document.createElement("a");
    link.setAttribute("href", Url);
    link.textContent = Label;
    link.onclick = event =>
      triggerNavigation({
        href: event.target.href,
        onFullPageNavigationCancelled: () => event.preventDefault()
      });

    return link;
  }

  return document.createTextNode(Label);
};

export default buildListItemMainContent;
